import { useEffect, useState } from 'react';
import type {
    IServiceActivity,
    IServiceWorkflowStep,
    IServiceWorkflowStepActivity,
    IServiceWorkflowTransition,
} from './workflowGraph/WorkflowGraph';
import { UrlBuilder } from '../../../../common/utils/urlBuilder';
import { fetchJson } from '../../../store/fetch';
import { WorkflowGraph } from './workflowGraph/WorkflowGraph';

interface IServiceWorkflowProps {
    serviceId: string;
}

export const ServiceWorkflow = (props: IServiceWorkflowProps) => {
    const [serviceWorkflowSteps, setServiceWorkflowSteps] = useState<IServiceWorkflowStep[]>([]);
    const [serviceWorkflowTransitions, setServiceWorkflowTransitions] = useState<IServiceWorkflowTransition[]>([]);
    const [serviceWorkflowStepActivities, setServiceWorkflowStepActivities] = useState<IServiceWorkflowStepActivity[]>(
        []
    );
    const [serviceActivities, setServiceActivities] = useState<IServiceActivity[]>([]);

    useEffect(() => {
        loadServiceWorkflow();
    }, []);

    return (
        <>
            {serviceWorkflowSteps.length > 0 && (
                <WorkflowGraph
                    serviceActivities={serviceActivities}
                    serviceWorkflowStepActivities={serviceWorkflowStepActivities}
                    serviceWorkflowSteps={serviceWorkflowSteps}
                    serviceWorkflowTransitions={serviceWorkflowTransitions}
                />
            )}
        </>
    );

    async function loadServiceWorkflow() {
        const url = new UrlBuilder(`/api/services/${props.serviceId}/serviceWorkflow`).build();
        const result = await fetchJson(url, 'GET');
        setServiceWorkflowSteps(result.json.steps);
        setServiceWorkflowTransitions(result.json.transitions);
        setServiceWorkflowStepActivities(result.json.stepActivities);
        setServiceActivities(result.json.activities);
    }
};
